import * as React from "react";
import BotProfilesEditor from "../Bots/BotProfilesEditor";

export default function BotManager() {
  return (
    <div className="pt-6 pl-10 pr-8 pb-10 max-w-5xl">
      <BotProfilesEditor />
    </div>
  );
}
